module.exports = __webpack_public_path__ + "img/buyOnebuy.fb770632.svg";